import { render, staticRenderFns } from "./AreaSearch.vue?vue&type=template&id=20370eb1&scoped=true&"
import script from "./AreaSearch.vue?vue&type=script&lang=js&"
export * from "./AreaSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20370eb1",
  null
  
)

export default component.exports